// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_bar {
    border-radius: 50px;
    background-color: #f5f5f6;
}

.nav_links {
    color: black;
}

.userHeader {
    cursor: pointer;
}

.userHeader .active {
    color: white;
    background-color: #45852e;
    border-radius: 50px;
}

/* .nav_notification {
  border-radius: 50%;
} */

.dropdown-toggle::after {
    border: none;
    margin-left: 0px;
}

.profile {
    /* padding-right: 20px; */
    border-radius: 30px;
    color: #ececec;
    background-color: rgba(0, 0, 0, 0.3);
    margin: 0px 20px;
    width: 200px;
    cursor: pointer;
    position: relative;
    font-family: "Karla";
}

.profile .span {
    height: 45px;
    width: 50px;
    padding: 9px;
    border-radius: 50%;
    background-color: #74a181;
    color: #ececec;
}

.obpass_details {
    background-color: #45852e;
    height: 200px;
    filter: drop-shadow(4px 4px 5px black);
}

.btn.logout-btn {
    border-color: rgb(69, 133, 46);
    color: rgb(69, 133, 46);
    width: 125px;
    border-radius: 8px;
}

.dropdown-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
    border-radius: 20px;
    width: 200px;
    box-sizing: border-box;
}

.left-dropdown-content {
    top: -17px;
    left: 103%;
}

.dropdown-content button,
.submenu-content button {
    background: none;
    border: none;
    cursor: pointer;
}

.dropdown-content div,
.submenu-content div {
    padding: 8px 12px;
    color: black;
}

.submenu-content div:hover {
    padding: 8px 12px;
    color: black;
    background-color: #ececec;
    border-radius: 12px;
}

.dropdown-content .span,
.submenu-content .span {
    background-color: unset;
}

.dropdown-item {
    display: flex;
    align-items: center;
}

.submenu-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 150px;
    left: -265px;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
    border-radius: 12px;
    width: 270px;
    box-sizing: border-box;
}

.text-sm {
    font-size: 12px;
}

.DP {
    height: 50px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 24px;
}

.menu-list {
    position: relative;
}

.menu-item {
    color: black;
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* width: 290px; */
}

.menu-item i {
    color: #45852e;
    font-size: 15px;
}

.dropdown-content > a:hover,
.dropdown-content > div:hover {
    background-color: #ebebeb7a;
}

.dropdown-content > div:first-child {
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
}

.dropdown-content > div:last-child {
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}

.userprofile-content a {
    color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/UserHeader.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,wCAAwC;IACxC,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,wCAAwC;IACxC,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".nav_bar {\n    border-radius: 50px;\n    background-color: #f5f5f6;\n}\n\n.nav_links {\n    color: black;\n}\n\n.userHeader {\n    cursor: pointer;\n}\n\n.userHeader .active {\n    color: white;\n    background-color: #45852e;\n    border-radius: 50px;\n}\n\n/* .nav_notification {\n  border-radius: 50%;\n} */\n\n.dropdown-toggle::after {\n    border: none;\n    margin-left: 0px;\n}\n\n.profile {\n    /* padding-right: 20px; */\n    border-radius: 30px;\n    color: #ececec;\n    background-color: rgba(0, 0, 0, 0.3);\n    margin: 0px 20px;\n    width: 200px;\n    cursor: pointer;\n    position: relative;\n    font-family: \"Karla\";\n}\n\n.profile .span {\n    height: 45px;\n    width: 50px;\n    padding: 9px;\n    border-radius: 50%;\n    background-color: #74a181;\n    color: #ececec;\n}\n\n.obpass_details {\n    background-color: #45852e;\n    height: 200px;\n    filter: drop-shadow(4px 4px 5px black);\n}\n\n.btn.logout-btn {\n    border-color: rgb(69, 133, 46);\n    color: rgb(69, 133, 46);\n    width: 125px;\n    border-radius: 8px;\n}\n\n.dropdown-content {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 100%;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    border-radius: 20px;\n    width: 200px;\n    box-sizing: border-box;\n}\n\n.left-dropdown-content {\n    top: -17px;\n    left: 103%;\n}\n\n.dropdown-content button,\n.submenu-content button {\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.dropdown-content div,\n.submenu-content div {\n    padding: 8px 12px;\n    color: black;\n}\n\n.submenu-content div:hover {\n    padding: 8px 12px;\n    color: black;\n    background-color: #ececec;\n    border-radius: 12px;\n}\n\n.dropdown-content .span,\n.submenu-content .span {\n    background-color: unset;\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n}\n\n.submenu-content {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 150px;\n    left: -265px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    border-radius: 12px;\n    width: 270px;\n    box-sizing: border-box;\n}\n\n.text-sm {\n    font-size: 12px;\n}\n\n.DP {\n    height: 50px;\n    width: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 24px;\n}\n\n.menu-list {\n    position: relative;\n}\n\n.menu-item {\n    color: black;\n    text-decoration: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* width: 290px; */\n}\n\n.menu-item i {\n    color: #45852e;\n    font-size: 15px;\n}\n\n.dropdown-content > a:hover,\n.dropdown-content > div:hover {\n    background-color: #ebebeb7a;\n}\n\n.dropdown-content > div:first-child {\n    border-top-right-radius: 20px;\n    border-top-left-radius: 20px;\n}\n\n.dropdown-content > div:last-child {\n    border-bottom-right-radius: 20px;\n    border-bottom-left-radius: 20px;\n}\n\n.userprofile-content a {\n    color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
